import request from "@/untils/request.js"

export const getOutpatientChargeStatistics = (params) => {
    return request.get("/outpatient/feelist/statics", {params} )
}

export const getChargesDetialPage = (params) => {
    return request.get("/outpatient/feelist/detailPage", {params} )
}

// 暴露
export default{
}